import { useMemo } from 'react';

import { useAppSelector } from 'store/hooks';

const useComment = () => {
  const { comment, paymentData } = useAppSelector((state) => state.payment);

  const isValidComment = useMemo(() => {
    if (paymentData?.requiredDescription) {
      return comment.length > 0;
    }

    return true;
  }, [comment, paymentData]);

  return {
    comment,
    isValidComment,
  };
};

export { useComment };
